import {
  checkCreatingStatus,
  checkDeletingStatus,
  checkFailedDelete,
  checkFailedReset,
  checkFailedStatus,
  checkSuspendedStatus,
} from '~/utils/site/helpers';

export const getCanShowManageInMenu = ({ status }: any) =>
  !checkCreatingStatus(status) &&
  !checkFailedStatus(status) &&
  !checkFailedReset(status) &&
  !checkDeletingStatus(status) &&
  !checkFailedDelete(status);

export const getCanShowManageInTitle = ({ status }: any) =>
  !checkCreatingStatus(status) &&
  !checkFailedStatus(status) &&
  !checkDeletingStatus(status) &&
  !checkFailedDelete(status);

export const getCanShowViewSite = ({ status }: any) =>
  !checkCreatingStatus(status) &&
  !checkFailedStatus(status) &&
  !checkFailedReset(status) &&
  !checkDeletingStatus(status) &&
  !checkFailedDelete(status) &&
  !checkSuspendedStatus(status);
